import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App.js'
import reportWebVitals from './reportWebVitals.js'
import { I18nextProvider } from 'react-i18next'
import i18next from 'i18next'
import common_en from './translation/en/common.json'
import common_ru from './translation/ru/common.json'
// ✅ Read ?lang from URL first
const params = new URLSearchParams(window.location.search)
const urlLang = params.get('lang')

// ✅ Read saved language from localStorage
const savedLang = localStorage.getItem('language')

// ✅ Final initial language: url → saved → EN default
const initialLang = urlLang || savedLang || 'en'
i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: initialLang, // language to use
  resources: {
    en: {
      common: common_en, // 'common' is our custom namespace
    },
    ru: {
      common: common_ru,
    },
  },
})

i18next.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng)

  const isFile = /\.(jpg|jpeg|png|gif|webp|mp4|svg|pdf|ico)$/.test(window.location.pathname)

  if (isFile) {
    // НЕ меняем адрес файлов (иначе ломается OG-image)
    return
  }

  const params = new URLSearchParams(window.location.search)
  params.set('lang', lng)

  window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`)
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
